module.exports = __webpack_public_path__ + "static/media/19ESCAP48.614f909e.jpg";